import request from '@/utils/request'

function unwrap(response) {
  const result = response.data
  if (result && result.code === 0) {
    return result
  }
  throw new Error((result && result.msg) || '月卡服务请求失败')
}

export function listParking99MonthOrders(params) {
  return request({
    url: '/parking99.listMonthOrders',
    method: 'get',
    params
  }).then(unwrap)
}

export function listParking99MonthAuthTypes(params) {
  return request({
    url: '/parking99.listMonthAuthTypes',
    method: 'get',
    params
  }).then(unwrap)
}

export function reviewParking99MonthApplication(data) {
  return request({
    url: '/parking99.reviewMonthApplication',
    method: 'post',
    data
  }).then(unwrap)
}
